
import React from 'react';
import { Modal } from 'react-bootstrap';
import { ReactComponent as IconClose } from '../../../node_modules/itd-common/assets/icons/close.svg';
import { ReactComponent as IconLeftArrow } from '../../../node_modules/itd-common/assets/icons/left-arrow.svg';
import './side-modal.scss';

type WidthProp = string | number; // p.ej. "35vw", "480px" o 480

interface SideModalProps {
  show: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  width?: WidthProp;
  backButton?: boolean;
}

const normalizeWidth = (width?: WidthProp) => {
  if (width === undefined || width === null) return undefined;
  // si viene número, asumimos px
  return typeof width === 'number' ? `${width}px` : width;
};

const SideModal: React.FC<SideModalProps> = ({
  show,
  onClose,
  title,
  children,
  width = '35vw',
  backButton
}) => {
  const cssWidth = normalizeWidth(width);
  
  // ✅ Tipamos el style para admitir la variable CSS
    const style: React.CSSProperties & { ['--side-modal-width']?: string } = {
      '--side-modal-width': cssWidth,
    };


  return (
    <Modal
      show={show}
      onHide={onClose}
      className="mi-modal fade"
      dialogClassName="mi-modal-dialog slide-horizonta"
      contentClassName="mi-modal-content"
      backdropClassName="mi-backdrop"
      centered={false}
      animation={true}
      style={style}
    >
      <Modal.Header>
        {title && (
          <Modal.Title>
            {backButton && (
              <button
                type="button"
                className="back-btn"
                aria-label="Volver"
                onClick={onClose}
              >
                <IconLeftArrow />
              </button>
            )}
            {title}
          </Modal.Title>
        )}
        <button
          type="button"
          className="mi-close-btn"
          aria-label="Cerrar"
          onClick={onClose}
        >
          <IconClose />
        </button>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default SideModal;